// extracted by mini-css-extract-plugin
export default {"title":"PageTitle-module__title--Sh4ux","subtitle":"PageTitle-module__subtitle--O919r","animatedBackground":"PageTitle-module__animatedBackground--guyYK"};